// Custom filter normalizers can be added here.
// Standard Normalizer will be default.
class filtersNormalizer {
	constructor(filtersData, app) {
		this.filtersData = filtersData;
		this.app = app;
	}

	getNormalizedFilters() {
		return this.normalizedFilters();
	}

	getNormalizedSort() {
		return this.normalizedSort();
	}

	// Standard Normalizer
	normalizedFilters = () => {
    if (this.app === 'events') {
      let eventsFiltersKeys = Object.keys(this.filtersData)
      .filter(key => Array.isArray(this.filtersData[key]));  // only keys with array values
      let eventsFilters = eventsFiltersKeys.map(key => {
        return {
          label: key === 'EventType' ? 'Event Type' : key === 'EngagementType' ? 'Access Type' : key,
          name: key,
          subFilters: this.filtersData[key].map(item => ({
            label: item.label,
            value: item.value
          }))
        };
      });
      return eventsFilters;
    } else {
      let filters = this.filtersData.Filters.map((filter) => {
        return {
          label: filter.Label,
          name: filter.Name,
          enableFilterSearch: filter.enableFilterSearch,
          searchInputText: filter.filterSearchInputText,
          subFilters: filter.subfilters,
        };
      });
      return filters;
    }
	};

	normalizedSort = () => {
		let sortBy = this.filtersData.Sort.map((sort) => {
			return {
				label: sort.sortLabel,
				value: sort.sortValue,
			};
		});

		return sortBy;
	};
}
export default filtersNormalizer;
